import { SseEventBase } from './sse-event-base.model';
import { SseEventType } from './sse-event-type.model';
import { runInInjectionContext } from '@angular/core';
import { RightsNotificationTypeEnum } from '../../enums/notification/rights-notification-type.enum';
import { MessageDesignBUtils } from '../../content/components/message-design-b/message-design-b.utils';
import { NotificationReasonEnum } from '../../enums/notification/notification-reason.enum';
import { TodoAction } from '../../states/todo/todo.action';

export class SseTodoEvent extends SseEventBase {

  type: SseEventType = 'todoNotification';

  onMessage = (event: MessageEvent<any>): void => {
    const resp = JSON.parse(event.data);

    if (this.hasEvents(resp)) {
      runInInjectionContext(this.injector, () => {
        resp.events.forEach(event => this.onEvent(resp, event));
      });
    }
  }

  private onEvent(resp: any, event: NotificationReasonEnum): void {
    this.ngZone.run(() => {
      switch (event) {
        case NotificationReasonEnum.TODOS_CHANGED: {
          this.store.dispatch(new TodoAction.FetchTodos());
          break;
        }
      }
    });
  }
}
